<template>
  <div class="app" id="login-page">
    <div class="login-form">
      <div class="content-w3ls">
        <div class="content-agile1">
          <div class="content-logo">
            <img src="../../img/logo.png" alt="logo" />
            <h3>TRANG QUẢN TRỊ</h3>
          </div>
        </div>
        <div class="content-agile2">
          <div class="title-login text-center">đổi mật khẩu</div>
          <el-form
            ref="myForm"
            :model="mData.dataForm"
            :rules="mData.validForm"
            label-width="120px"
            label-position="top"
            @submit.native.prevent
          >
            <b-alert
              style="padding: 10px"
              variant="danger"
              dismissible
              :show="mData.dataDefault.showDismissibleAlert"
              @dismissed="mData.dataDefault.showDismissibleAlert = false"
              >{{ mData.dataDefault.error }}</b-alert
            >
            <el-form-item label="Tên đăng nhập" prop="account">
              <el-input
                v-model="mData.dataForm.account"
                @change="fn_reset()"
                disabled
                @input="forceUpdateUI"
                size="medium"
              ></el-input>
            </el-form-item>
            <el-form-item label="Mật khẩu cũ" prop="password">
              <el-input
                type="password"
                size="medium"
                v-model="mData.dataForm.password"
                change
                show-password
                @input="forceUpdateUI"
              ></el-input>
            </el-form-item>
            <el-form-item label="Mật khẩu mới" prop="passwordNew">
              <el-input
                type="password"
                size="medium"
                v-model="mData.dataForm.passwordNew"
                show-password
                @input="forceUpdateUI"
              ></el-input>
            </el-form-item>
            <el-form-item class="form-btn" style="margin-bottom: 0">
              <el-button
                type="primary"
                class="btn-next"
                native-type="submit"
                v-ladda
                @click="fn_changePassword()"
                >Đổi mật khẩu</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import DataForm from "../../dataForm/dataFormUser";
import MethodService from "../../service/MethodService";

export default {
  data() {
    return {
      id: {},
      width: window.screen.width,
      height: window.screen.height,
      setT: "",
      aLang: LanguageService.lang,

      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
        },
        dataForm: MethodService.copyObject(DataForm.dataForm),
        validForm: {
          account: [ValidService.required, ValidService.requiredChange],
          password: [ValidService.required],
          passwordNew: [ValidService.required],
        },
      },
    };
  },

  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    async fn_initForm() {
      this.id = localStorage.getItem("currentUser");
      let idUser = JSON.parse(this.id);
      console.log("1111324", idUser.id);
      this.mData.dataForm.account = idUser.account;
    },
    fn_reset() {
      this.mData.dataForm.account = this.mData.dataForm.account;
    },
    fn_changePassword() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          AuthService.changePassword(
            this.mData.dataForm.account,
            this.mData.dataForm.password,
            this.mData.dataForm.passwordNew
          )
            .then(() => {
              if (
                this.mData.dataForm.password === this.mData.dataForm.passwordNew
              ) {
                window.toastr.warning("Mật khẩu mới trùng mật khẩu cũ");
                MethodService.stopLadda();
              } else {
                window.toastr.success("Đổi mật khẩu thành công");
                this.$router.push({ name: "Auth-Login" });
              }
            })
            .catch((e) => {
              console.log(e);
              MethodService.stopLadda();
              if (e.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (e.code === 2) {
                window.toastr.error("Máy chủ không phản hồi");
              } else
                window.toastr.error(
                  "Mật khẩu cũ không đúng vui lòng nhập lại!"
                );
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
  },
  mounted: function () {},
  async created() {
    await this.fn_initForm();
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute);
  },
};
</script>

<style scoped>
.form-btn {
  margin: 15px 0;
  text-align: center;
}
.btn-next {
  min-width: 150px;
  background-color: #9e1c1e;
  transition: 0.3s !important;
  color: #fff;
  border: 1px solid #9e1c1e;
}
.btn-next:hover {
  background-color: #e0ab45;
  border: 1px solid #e0ab45;
}

#login-page {
  background: url("../../img/gioi-thieu-background-grid.png") no-repeat center
      center,
    url("../../img/gioi-thieu-background-cloud.png") no-repeat center center,
    #9e1c1e;
  padding: 15px;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
}

img {
  max-width: 100%;
}

.login-form {
  width: 100%;
}
.form-login form {
  min-height: 410px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content-w3ls {
  display: block;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
  background-color: #fff;
  width: 100%;
  position: relative;
}
.content-w3ls::before {
  content: "";
  position: absolute;
  background: url("../../img/gioi-thieu-hoa-trai.png");
  background-repeat: no-repeat;
  width: 207px;
  height: 224px;
  z-index: 10;
  left: -93px;
  bottom: -105px;
  display: none;
}
.content-w3ls::after {
  content: "";
  position: absolute;
  background: url("../../img/hoa-phai.png");
  background-repeat: no-repeat;
  width: 207px;
  height: 224px;
  z-index: 10;
  right: -202px;
  top: 68px;
  display: none;
}
.content-agile1 {
  background-color: #fff1dc;
  width: 50%;
  display: none;
  justify-content: center;
}
.content-agile2 {
  width: 100%;
}
.content-agile1,
.content-agile2 {
  position: relative;
}
.content-agile1::before,
.content-agile2::before {
  position: absolute;
  content: "";
  height: 13px;
  background: linear-gradient(
    180deg,
    #f9bc60 0%,
    #ffca78 20.31%,
    #fed9b7 53.12%,
    #fac96a 76.04%,
    #e0ab45 100%
  );
  left: 0;
  bottom: 0;
  width: 100%;
}
.content-logo {
  background-color: #003168;
  width: 250px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 0 10px 0;
}
.content-logo h3 {
  font-size: 25px;
  font-family: "Noh Carborne";
  background: -webkit-linear-gradient(
    #f9bc60 0%,
    #ffca78 20.31%,
    #fed9b7 53.12%,
    #fac96a 76.04%,
    #e0ab45 100%
  );
  -webkit-background-clip: text;
  padding: 15px;
  margin-top: 20px;
  background-clip: text;
  color: transparent;
}

.title-login {
  background: #fff1dc;

  color: #9e1c1e;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 25px;
  padding: 30px 30px;
}
.content-w3ls .content-agile2 .el-form {
  padding: 30px 40px;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9e1c1e;
}

/*-- responsive design --*/
@media (min-width: 991px) {
  .content-w3ls {
    display: flex;
  }
  .content-w3ls::before,
  .content-w3ls::after {
    display: block;
  }
  .content-agile1 {
    display: flex;
  }
  .content-agile2 {
    width: 50%;
  }
  #login-page {
    align-items: center;
  }
  .login-form {
    max-width: 900px;
  }
}
</style>
